angular.module('unergie.main')
.controller('contractDocumentsModalCtrl', ($scope, $uibModal, $uibModalInstance, ApiAdmin, ApiUser, ModalService, BoFeaturesService,
    AlertManager, MetaWatcher, AdminComments, DataAccess, ErrorCatcher, contract, irrecoverabilityCertificates, EnvUtils, DownloadService) => {
    $scope.contract = contract
    $scope.irrecoverabilityCertificates = _.filter(irrecoverabilityCertificates, (certif) => !['CANCELLED'].includes(certif.status))
    const feats = BoFeaturesService.getModuleFeatures('contracts')
    const canDlTerminatedContractCertif = BoFeaturesService.isFeatureOn('canDlTerminatedContractCertif')
    $scope.isCFeatureOn = (feature) => feats[feature]
    const ACTIVATED_STATUSES = [2, 14, 15]
    const BILLING_SITUATION_STATUSES = [2, 4, 14, 15]
    $scope.isContractActivated = (flex) => ACTIVATED_STATUSES.includes($scope.contract.status) || (flex && canDlTerminatedContractCertif && $scope.contract.status === 4)
    DataAccess.accountInfoLight({ id_account: $scope.contract.id_account }).$promise.then((accountResult) => {
        $scope.isSmallBusiness = accountResult.category === 'small-business'
    })
    // Contract certificates
    $scope.sendCertificateEmail = () =>
        ApiUser.adminSendMail({ id_contract: $scope.contract.id, id_account: $scope.contract.id_account }, { template: 'contract_certificate' }).$promise.then(() => {
            AlertManager.success(`Email envoyé`)
            const comment = '<b>AUTOMATIQUE</b> : attestation de contrat envoyé par email'
            AdminComments.addComment({ object: $scope.contract.id, comment }).$promise.catch(ErrorCatcher)
            MetaWatcher.notif('CONTRACT_CHANGED', $scope.contract)
        }).catch(ErrorCatcher)

    $scope.downloadCertificate = () => {
        DownloadService.downloadFile(`/api-user/documents/${contract.id}/contractcertificate`, true)
    }

    // Timetable
    $scope.fetchingTimetablesFromS3 = true

    ApiAdmin.listContractS3Timetables({ id_contract: $scope.contract.id }).$promise.then((timetables) => {
        $scope.downloadableTimetables = _.map(timetables, ({ Key }) => {
            const customerId = Key.split('/').splice(1, 1)[0]
            const filename = Key.split('/').pop()

            return {
                label: filename.replace(/.+(\d{1,2}-\d{1,2}-\d{2,4}).pdf/, `Télécharger l'échéancier du $1`).replace(/-/g, '/'),
                filename,
                customerId,
            }
        })
    })
    .catch(ErrorCatcher)
    .finally(() => {
        $scope.fetchingTimetablesFromS3 = false
    })

    $scope.sendTimetableMail = () =>
        ApiUser.adminSendMail({ id_contract: $scope.contract.id, id_account: $scope.contract.id_account }, { template: 'timetable_modif' }).$promise.then(() => {
            AlertManager.success(`Email envoyé`)
            const comment = '<b>AUTOMATIQUE</b> : échéancier envoyé par email'
            AdminComments.addComment({ object: $scope.contract.id, comment }).$promise.catch(ErrorCatcher)
            MetaWatcher.notif('CONTACTS_CHANGED')
        }).catch(ErrorCatcher)

    // Proof of residence
    $scope.getPoRButtonTitle = () => (ACTIVATED_STATUSES.includes($scope.contract.status)
        ? 'Générer un justificatif de domicile'
        : 'Le contrat doit être "En service" pour pouvoir éditer un justificatif de domicile')

    $scope.openProofOfResidenceModal = () => {
        ModalService.openModal({ type: 'proofOfResidenceModal', size: 'lg' }, { idAccount: $scope.contract.id_account, idContract: $scope.contract.id })
    }

    // Billing situation
    $scope.canDLBillingSituation = () => BILLING_SITUATION_STATUSES.includes($scope.contract.status)

    $scope.sendBillingSituationMail = () =>
        ApiUser.adminSendMail({ id_contract: $scope.contract.id, id_account: $scope.contract.id_account }, { template: 'billing_situation' }).$promise.then(() => {
            AlertManager.success(`Email envoyé`)
            const comment = '<b>AUTOMATIQUE</b> : avis de sitution envoyé par email'
            AdminComments.addComment({ object: $scope.contract.id, comment }).$promise.catch(ErrorCatcher)
            MetaWatcher.notif('CONTRACT_CHANGED', $scope.contract)
        }).catch(ErrorCatcher)

    // Irrecoverability certificates
    $scope.downloadIrrecoverabilityCertificate = (id) => {
        DownloadService.downloadFile(`/api-user/irrecoverability-certificate/${id}/download`, true)
    }

    // FIS
    $scope.sendFisMail = () => {
        ApiAdmin.sendMailFis({ id_contract: $scope.contract.id }, {}).$promise.then(() => {
            AlertManager.success(`Email envoyé`)
            const comment = '<b>AUTOMATIQUE</b> : FIS envoyée par email'
            AdminComments.addComment({ object: $scope.contract.id, comment }).$promise.catch(ErrorCatcher)
            MetaWatcher.notif('CONTRACT_CHANGED', $scope.contract)
        }).catch(ErrorCatcher)
    }

    $scope.downloadFis = () => {
        let file = `${EnvUtils.selfcareUrl}/documentation/${contract.providerOffer.fis || 'fis.pdf'}`

        // @TODO: replace after unique offer referential is done
        if (['OFFRE_UFC', 'OFFRE_PETITS_PRODUCTEURS'].includes(contract.providerOffer.id) && contract.commissioning_date) {
            if (moment(contract.commissioning_date).add('1', 'y').isBefore(moment.now())) {
                file = file.replace(/(.*)(\.pdf)$/, '$1_annee_2$2')
            }
        }

        DownloadService.downloadFile(file)
    }

    $scope.ok = () => $uibModalInstance.close()
    $scope.close = () => $uibModalInstance.dismiss()
})
